var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBosnia01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282.65 282.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .bosnia-1 {\n        fill: #fecc00;\n      }\n\n      .bosnia-2 {\n        fill: #fff;\n      }\n\n      .bosnia-3 {\n        fill: #001e96;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "bosnia-3",
    d: "M282.65,141.33c0,51.81-27.89,97.12-69.47,121.72-4.15,2.46-8.44,4.71-12.86,6.73-6.41,2.96-13.08,5.44-19.96,7.41-9.04,2.59-18.45,4.31-28.13,5.05l.54.42h-11.45C63.28,282.65,0,219.38,0,141.33c0-2.89.09-5.77.26-8.62.05-.78.1-1.56.16-2.34.17-2.24.39-4.46.67-6.67.01-.12.03-.23.05-.34h0c1.12-8.84,3.06-17.42,5.73-25.66.29-.9.6-1.81.91-2.7,1.52-4.38,3.25-8.67,5.18-12.84C35.34,33.65,84.41,0,141.33,0c26.24,0,50.81,7.15,71.86,19.61,41.58,24.6,69.47,69.9,69.47,121.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bosnia-1",
    d: "M213.19,19.61v243.44c-4.15,2.46-8.44,4.71-12.86,6.73L12.96,82.15C35.34,33.65,84.41,0,141.33,0c26.24,0,50.81,7.15,71.86,19.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "bosnia-2",
    d: "M187.29,271.88l-6.93,5.31c-9.04,2.59-18.45,4.31-28.13,5.05h0l-13.51-10.35h18.36s5.92-17.75,5.92-17.75l5.92,17.77h18.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "bosnia-2",
    points: "151.91 236.5 133.55 236.52 127.63 218.75 121.71 236.52 103.34 236.5 118 247.74 112.44 265.35 127.63 254.67 142.81 265.35 137.26 247.74 151.91 236.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "bosnia-2",
    points: "116.53 201.12 98.17 201.14 92.25 183.38 86.33 201.14 67.96 201.12 82.62 212.36 77.07 229.97 92.25 219.29 107.43 229.97 101.88 212.36 116.53 201.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "bosnia-2",
    points: "81.15 165.74 62.79 165.76 56.87 148 50.95 165.76 32.58 165.74 47.24 176.98 41.69 194.59 56.87 183.91 72.05 194.59 66.5 176.98 81.15 165.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bosnia-2",
    d: "M31.12,141.6l5.56,17.62-15.18-10.68-15.18,10.68,5.55-17.62L.26,132.71c.05-.78.1-1.56.16-2.34h15.15s5.92-17.75,5.92-17.75l5.92,17.76h18.37s-14.66,11.22-14.66,11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bosnia-2",
    d: "M1.14,123.35l.15.48-.2-.14c.01-.12.03-.23.05-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bosnia-2",
    d: "M10.39,94.98l-3.53,2.7c.29-.9.6-1.81.91-2.7h2.62Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosnia01);
export default __webpack_public_path__ + "static/media/Bosnia-01.cc87602427d39ec5cf8cc963652342f7.svg";
export { ForwardRef as ReactComponent };